export const generateMockInitData = async () => {
  const urlParams = new URLSearchParams(window.location.search);

  const telegramId =
    urlParams.get("mock_id") || import.meta.env.VITE_TELEGRAM_ID;
  const telegramUsername =
    urlParams.get("mock_username") || import.meta.env.VITE_TELEGRAM_USERNAME;
  const telegramFirstName =
    urlParams.get("mock_first_name") || import.meta.env.VITE_TELEGRAM_FIRSTNAME;
  const telegramLastName =
    urlParams.get("mock_last_name") || import.meta.env.VITE_TELEGRAM_LASTNAME;
  const botToken = import.meta.env.VITE_TELEGRAM_BOT_TOKEN;

  if (
    !telegramId ||
    !telegramUsername ||
    !telegramFirstName ||
    !telegramLastName ||
    !botToken
  ) {
    throw new Error("Missing required environment variables");
  }

  const authDate = Math.floor(Date.now() / 1000);

  const user = {
    id: Number(telegramId),
    is_bot: false,
    first_name: telegramFirstName,
    last_name: telegramLastName,
    username: telegramUsername,
    language_code: "en",
  };

  const params = new URLSearchParams({
    user: JSON.stringify(user),
    auth_date: authDate.toString(),
    query_id: "mock-query-id",
  });

  // Telegram's two-step HMAC validation process:
  // Step 1: secret_key = HMAC_SHA256(key="WebAppData", message=bot_token)
  // Step 2: hash = HMAC_SHA256(key=secret_key, message=data_check_string)

  const encoder = new TextEncoder();

  // Step 1: Generate secret_key = HMAC_SHA256(key="WebAppData", message=botToken)
  const webAppDataKey = await crypto.subtle.importKey(
    "raw",
    encoder.encode("WebAppData"),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );

  const secretKeySignature = await crypto.subtle.sign(
    "HMAC",
    webAppDataKey,
    encoder.encode(botToken),
  );
  const secretKeyBytes = new Uint8Array(secretKeySignature);

  // Step 2: Build data_check_string (sorted params except hash, joined by \n)
  const dataCheckString = Array.from(params.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => `${k}=${v}`)
    .join("\n");

  // Step 3: Compute hash using secret_key
  const secretKey = await crypto.subtle.importKey(
    "raw",
    secretKeyBytes,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );

  const hashSignature = await crypto.subtle.sign(
    "HMAC",
    secretKey,
    encoder.encode(dataCheckString),
  );

  const hash = Array.from(new Uint8Array(hashSignature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  console.log(
    "Debug [Frontend] - botToken (first 10 chars):",
    botToken.substring(0, 10),
  );
  console.log(
    "Debug [Frontend] - secretKeyBytes (hex, first 20 chars):",
    Array.from(secretKeyBytes.slice(0, 10))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""),
  );
  console.log("Debug [Frontend] - dataCheckString:", dataCheckString);
  console.log("Debug [Frontend] - generatedHash:", hash);

  params.append("hash", hash);

  return params.toString();
};
